export const sources = {
	webp: "__VITE_ASSET__ykb1zIozoJBMq4UvQnlhcQ__ 400w, __VITE_ASSET__BjjUHagISQHtPWYmu3KuwQ__ 800w"
};
export const img = {
	src: "__VITE_ASSET__BjjUHagISQHtPWYmu3KuwQ__",
	w: 800,
	h: 533
};
export default {
	sources: sources,
	img: img
};
